import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import {DeleteForeverRounded, OpenInFullRounded} from "@mui/icons-material";
import { Popconfirm, message, Menu, Dropdown, List, Typography, Space } from 'antd';
import { selectAllBuilders, clearBuilderState } from '../../Store/slices/appState.slice';
import { DoubleLine } from "../../Components/Labels";
import { portfolioTypeString } from "../../utils/strings";
import { useBuilder } from "../../Contexts/BuilderContext";

const BuilderStatesManager = () => {
    const builders = useSelector(selectAllBuilders);
    const { setPortfolioBuilder } = useBuilder();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);


    const handleOpenDraft = (builderId) => {
        setPortfolioBuilder(builders[builderId]);
        navigate('/builders/portfolio');
    };

    const handleDeleteBuilder = (stateId) => {
        dispatch(clearBuilderState({ stateId }));
        setSelectedRowKeys(selectedRowKeys.filter(key => key !== stateId));
    };

    const handleDeleteSelected = () => {
        selectedRowKeys.forEach(stateId => dispatch(clearBuilderState({ stateId })));
        setSelectedRowKeys([]);
    };

    const canMerge = selectedRowKeys.length > 1; // Simple validation: at least two must be selected to merge

    const handleMergeSelected = () => {
        if (!canMerge) {
            message.error('Select at least two drafts to merge');
            return;
        }
        // Implement merge logic here
        message.success('Merge successful'); // Placeholder success message
    };

    const menu = (
        <Menu>
            <Menu.Item key="1" onClick={handleDeleteSelected} disabled={selectedRowKeys.length === 0}>
                Remove Selected
            </Menu.Item>
            <Menu.Item key="2" onClick={handleMergeSelected} disabled={!canMerge}>
                Merge Selected
            </Menu.Item>
        </Menu>
    );



    const data = Object.keys(builders).map(key => ({
        key: key,
        stateId: builders[key].stateId,
        name: builders[key].title,
        type: builders[key].type,
        items: builders[key].items,
    }));

    return (
        <>
            <Dropdown overlay={menu} placement="bottomCenter">
                <Button type="primary" style={{ marginBottom: 16 }}>
                    Actions for Selected
                </Button>
            </Dropdown>
            <List
                dataSource={data}
                renderItem={(item) => (
                    <List.Item key={item.key}>
                        <List.Item.Meta
                            title={<Typography.Title level={5}>{item.name} ({portfolioTypeString(item.type)})</Typography.Title>}
                            description={
                                <span>{item.items?.length ?? 0} items</span>
                            }
                        />

                        <Space>
                            <Button startIcon={<OpenInFullRounded/>} variant={'contained'} onClick={() => handleOpenDraft(item.stateId)}>Open</Button>
                            <Popconfirm
                                title="Are you sure you want to delete this builder?"
                                onConfirm={() => handleDeleteBuilder(item.stateId)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button startIcon={<DeleteForeverRounded/>} variant={'outlined'} color={'error'}>Delete</Button>
                            </Popconfirm>
                        </Space>
                    </List.Item>
                )}
            />
        </>
    );
};

export default BuilderStatesManager;
